import React from 'react'

interface PriceTableCellProps {
  children?: React.ReactNode
  style?: React.CSSProperties
}

const PriceTableCell: React.FC<PriceTableCellProps> = ({ children, style }) => {
  return <td style={{ paddingTop: '2px', paddingBottom: '2px', ...style }}>{children}</td>
}

export default PriceTableCell
